; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('formatList', formatList)

  function formatList () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        src: '<',
        standard: '<',
        standardFilter: '<',
        onLoad: '&',
        onCreate: '&'
      },
      templateUrl: '/arts/directives/format-list/format-list-directive.html?$$REVISION$$',
      controller: 'FormatListController'
    }
  }
})()
